import React from 'react';

import { ReactComponent as ClockIcon } from 'assets/icons/connectivity/clock-small.svg';

import { BANNER_COPY, BANNER_VARIANT } from '../../constants';

import styles from './SlowConnectionHint.module.css';

const { title, body } = BANNER_COPY[BANNER_VARIANT.SLOW];

function SlowConnectionHint() {
    return (
        <div className={styles.hint}>
            <ClockIcon
                width={18}
                height={18}
                className={styles.icon}
                aria-hidden="true"
                focusable="false"
            />
            <div className={styles.text}>
                <p className={styles.title}>{title}</p>
                <p className={styles.body}>{body}</p>
            </div>
        </div>
    );
}

export default SlowConnectionHint;
